import type { BaseTemplateConfig } from "../app/schemas/template";

export interface ClientEventMetadataOverrides {
  coupleDisplayName?: string;
  coupleKeywordName?: string;
  weddingDateText?: string;
}

export interface ClientConfig<TTemplate extends BaseTemplateConfig = BaseTemplateConfig> {
  eventCode: string;
  template: TTemplate;
  event?: ClientEventMetadataOverrides;
}

export function defineClientConfig<TTemplate extends BaseTemplateConfig>(config: ClientConfig<TTemplate>) {
  return config;
}
